(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aleva-cart-before-gift-stock-qa-20261017"]) return;
  try {
    
  (() => {
    const cartRoot = document.querySelector("[data-aleva-cart]");
    if (!cartRoot) return;

    const translationNode =
      document.getElementById("AlevaCartTranslations");

    let cartTranslations = {};

    try {
      cartTranslations = JSON.parse(
        translationNode?.textContent || "{}"
      );
    } catch (error) {
      console.error(
        "ALEVA cart translations parse error:",
        error
      );
    }

    const cartText = key =>
      cartTranslations[key] || key;

    const cartTemplate = (value, variables = {}) =>
      String(value).replace(
        /__([A-Z]+)__/g,
        (_, key) =>
          variables[key.toLowerCase()] ?? ""
      );

    function syncCartCountBreakdown() {
      const count =
        document.getElementById(
          "alevaCartCountBreakdown"
        );

      if (!count) return;

      const paid =
        Number(count.dataset.paidCount || 0);

      const gifts =
        Number(count.dataset.giftCount || 0);

      let key = "countItems";

      if (gifts > 0) {
        if (paid === 1 && gifts === 1) {
          key = "countOneItemOneGift";
        } else if (paid === 1) {
          key = "countOneItemGifts";
        } else if (gifts === 1) {
          key = "countItemsOneGift";
        } else {
          key = "countItemsGifts";
        }
      } else if (paid === 1) {
        key = "countOneItem";
      }

      count.textContent = cartTemplate(
        cartText(key),
        {
          count: paid,
          paid,
          gifts
        }
      );
    }

    function syncHeaderPaidCartCount() {
      const paid =
        Number(
          cartRoot.dataset.paidItemCount || 0
        );

      const ariaKey =
        paid === 1
          ? "headerCartOne"
          : "headerCartMany";

      const ariaLabel = cartTemplate(
        cartText(ariaKey),
        { count: paid }
      );

      document
        .querySelectorAll(".cart-count")
        .forEach(element => {
          element.textContent =
            String(paid);

          element.setAttribute(
            "aria-label",
            ariaLabel
          );
        });
    }
    let isUpdating = false;
    let giftSize = "50 ML";
    let giftFilter = "all";
    let giftToastTimer;

    const shopRoot =
      window.Shopify?.routes?.root || "/";

    const addUrl =
      `${shopRoot}cart/add.js`;

    const changeUrl =
      `${shopRoot}cart/change.js`;

    const updateUrl =
      `${shopRoot}cart/update.js`;

    const cartJsonUrl =
      `${shopRoot}cart.js`;

    const giftBox =
      document.getElementById("AlevaGiftExperience");

    const drawer =
      document.getElementById("AlevaGiftDrawer");

    const pickerSize =
      document.getElementById("AlevaGiftPickerSize");

    const search =
      document.getElementById("AlevaGiftSearch");

    const emptyResults =
      document.getElementById("AlevaGiftEmptyResults");

    const toast =
      document.getElementById("AlevaGiftToast");

    const giftCards =
      [...document.querySelectorAll("[data-gift-card]")];
    const eligibleOfferProductIds =
      new Set(
        giftCards
          .map(card =>
            String(card.dataset.productId || "")
          )
          .filter(Boolean)
      );

    function showGiftToast(message) {
      if (!toast) return;

      toast.textContent = message;
      toast.classList.add("is-visible");

      clearTimeout(giftToastTimer);

      giftToastTimer = setTimeout(
        () => toast.classList.remove("is-visible"),
        2200
      );
    }

    function giftStatusText(progress) {
      const ready =
        progress.dataset.ready === "true";

      if (ready) {
        return cartText("giftProgressReady");
      }

      const remaining =
        Number(progress.dataset.remaining || 0);

      return cartTemplate(
        cartText("giftProgressNeed"),
        { count: remaining }
      );
    }

    function syncGiftProgressLanguage() {
      document
        .querySelectorAll("[data-gift-progress]")
        .forEach(progress => {
          const status =
            progress.querySelector(
              ".aleva-gift-progress__status"
            );

          if (status) {
            status.textContent =
              giftStatusText(progress);
          }
        });
    }

    async function getCartJson() {
      const response = await fetch(cartJsonUrl, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          "Cart fetch failed."
        );
      }

      return data;
    }

    function getAlevaGiftLines(cart, size = null) {
      return (cart?.items || [])
        .map((item, index) => ({
          item,
          line: index + 1
        }))
        .filter(({ item }) => {
          const isGift =
            String(
              item?.properties?._aleva_gift || ""
            ) === "true";

          if (!isGift) return false;
          if (!size) return true;

          return (
            String(
              item?.properties?._aleva_gift_size || ""
            ) === size
          );
        });
    }

    async function removeAlevaGiftLines(size = null) {
      let cart = await getCartJson();

      const giftLines =
        getAlevaGiftLines(cart, size)
          .sort((a, b) => b.line - a.line);

      for (const giftLine of giftLines) {
        const response = await fetch(
          changeUrl,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
              "Accept":
                "application/json",
              "X-Requested-With":
                "XMLHttpRequest"
            },
            body: JSON.stringify({
              line: giftLine.line,
              quantity: 0
            })
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            "Gift line removal failed."
          );
        }

        cart = data;
      }

      return cart;
    }

    async function addAlevaGiftLine({
      variantId,
      size,
      sku,
      handle
    }) {
      if (!variantId) {
        throw new Error(
          "Missing ALEVA gift variant ID."
        );
      }

      const response = await fetch(
        addUrl,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            "Accept":
              "application/json",
            "X-Requested-With":
              "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: {
                  "_aleva_gift": "true",
                  "_aleva_gift_offer": "4+1",
                  "_aleva_gift_size":
                    size || "",
                  "_aleva_gift_sku":
                    sku || "",
                  "_aleva_gift_handle":
                    handle || ""
                }
              }
            ]
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          "Gift line add failed."
        );
      }

      return data;
    }

    async function clearGift(size, options = {}) {
      if (!size) return;
      if (isUpdating && !options.force) return;

      const previousUpdatingState =
        isUpdating;

      isUpdating = true;

      try {
        await removeAlevaGiftLines(size);

        if (!options.silent) {
          showGiftToast(
            cartText("giftRemovedToast")
          );
        }

        window.setTimeout(
          () => window.location.reload(),
          options.silent ? 0 : 350
        );

      } catch (error) {
        console.error(
          "ALEVA gift remove error:",
          error
        );

        isUpdating =
          previousUpdatingState;
      }
    }

function cardAvailableForSize(card) {
  const attribute =
    giftSize === "100 ML"
      ? "data-variant-100"
      : "data-variant-50";

  return Boolean(
    card.getAttribute(attribute)
  );
}
    function filterGiftCards() {
      const term =
        (search?.value || "")
          .trim()
          .toLowerCase();

      let visible = 0;

      giftCards.forEach(card => {
        const matchesSize =
          cardAvailableForSize(card);

        const matchesFilter =
          giftFilter === "all" ||
          card.dataset.category === giftFilter;

        const matchesSearch =
          !term ||
          (card.dataset.search || "")
            .includes(term);

        const show =
          matchesSize &&
          matchesFilter &&
          matchesSearch;

        card.hidden = !show;

        if (show) visible += 1;
      });

      if (emptyResults) {
        emptyResults.hidden = visible > 0;
      }
    }

    function openGiftDrawer(size) {
      if (!drawer) return;

      giftSize = size || "50 ML";

      if (pickerSize) {
        pickerSize.textContent = giftSize;
      }

      if (search) {
        search.value = "";
      }

      giftFilter = "all";

      document
        .querySelectorAll("[data-gift-filter]")
        .forEach(button => {
          button.classList.toggle(
            "is-active",
            button.dataset.giftFilter === "all"
          );
        });

      filterGiftCards();

      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("aleva-gift-lock");

      window.setTimeout(
        () => search?.focus(),
        280
      );
    }

    function closeGiftDrawer() {
      if (!drawer) return;

      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("aleva-gift-lock");
    }

    document
      .querySelectorAll("[data-gift-open]")
      .forEach(button => {
        button.addEventListener("click", () => {
          openGiftDrawer(
            button.dataset.size || "50 ML"
          );
        });
      });

    document
      .querySelectorAll("[data-gift-close]")
      .forEach(button => {
        button.addEventListener(
          "click",
          closeGiftDrawer
        );
      });

    document
      .querySelectorAll("[data-gift-remove]")
      .forEach(button => {
        button.addEventListener(
          "click",
          () => clearGift(
            button.dataset.size || ""
          )
        );
      });

    document
      .querySelectorAll("[data-gift-filter]")
      .forEach(button => {
        button.addEventListener("click", () => {
          giftFilter =
            button.dataset.giftFilter || "all";

          document
            .querySelectorAll("[data-gift-filter]")
            .forEach(item => {
              item.classList.toggle(
                "is-active",
                item === button
              );
            });

          filterGiftCards();
        });
      });

    search?.addEventListener(
      "input",
      filterGiftCards
    );

    document.addEventListener(
      "keydown",
      event => {
        if (
          event.key === "Escape" &&
          drawer?.classList.contains("is-open")
        ) {
          closeGiftDrawer();
        }
      }
    );

    giftCards.forEach(card => {
      const button =
        card.querySelector(
          "[data-gift-select]"
        );

      button?.addEventListener(
        "click",
        async () => {
          if (isUpdating) return;

          const is100 =
            giftSize === "100 ML";

          const variantId =
            is100
              ? card.getAttribute(
                  "data-variant-100"
                )
              : card.getAttribute(
                  "data-variant-50"
                );

          const sku =
            is100
              ? card.getAttribute(
                  "data-sku-100"
                )
              : card.getAttribute(
                  "data-sku-50"
                );

          /*
            The gift drawer is only exposed from an eligible
            4+1 state, so do not block selection again using
            a duplicated frontend unlock flag. If a variant ID
            exists, Shopify's Cart Ajax API is the final source
            of truth for whether it can be added.
          */
          if (!variantId) {
            showGiftToast(
              cartText("giftUnavailable")
            );
            return;
          }

          isUpdating = true;
          button.disabled = true;

          try {
            /*
              Replace only the gift for the current
              size. A 50 ML gift and a 100 ML gift
              can therefore exist at the same time.
            */
            await removeAlevaGiftLines(
              giftSize
            );

            await addAlevaGiftLine({
              variantId,
              size: giftSize,
              sku: sku || "",
              handle:
                card.dataset.handle || ""
            });

            closeGiftDrawer();

            showGiftToast(
              cartTemplate(
                cartText("giftSavedToast"),
                {
                  name:
                    card.dataset.title || ""
                }
              )
            );

            window.setTimeout(
              () => window.location.reload(),
              520
            );

          } catch (error) {
            console.error(
              "ALEVA gift select error:",
              error
            );

            /*
              Clean only the gift for the size that
              failed. Never remove the other size.
            */
            try {
              await removeAlevaGiftLines(
                giftSize
              );
            } catch (cleanupError) {
              console.error(
                "ALEVA gift cleanup error:",
                cleanupError
              );
            }

            const shopifyMessage =
              error?.message || "";

            showGiftToast(
              shopifyMessage &&
              shopifyMessage !==
                "Gift line add failed."
                ? shopifyMessage
                : cartText("giftError")
            );

            button.disabled = false;
            isUpdating = false;
          }
        }
      );
    });

    function qualifyingCountsFromCart(cart) {
      let count50 = 0;
      let count100 = 0;

      (cart?.items || []).forEach(item => {
        const isGift =
          String(
            item?.properties?._aleva_gift || ""
          ) === "true";

        if (isGift) return;

        const productId =
          String(item?.product_id || "");

        if (!eligibleOfferProductIds.has(productId)) {
          return;
        }

        const variantTitle =
          String(
            item?.variant_title || ""
          )
            .toUpperCase()
            .trim();

        if (variantTitle.includes("50 ML")) {
          count50 += Number(item.quantity || 0);
        } else if (
          variantTitle.includes("100 ML")
        ) {
          count100 += Number(item.quantity || 0);
        }
      });

      return {
        count50,
        count100
      };
    }

    async function removeNoLongerEarnedGifts(cart) {
      const {
        count50,
        count100
      } = qualifyingCountsFromCart(cart);

      if (count50 < 4) {
        await removeAlevaGiftLines(
          "50 ML"
        );
      }

      if (count100 < 4) {
        await removeAlevaGiftLines(
          "100 ML"
        );
      }
    }

    async function changeQuantity(item, quantity) {
      if (!item || isUpdating) return;

      const line =
        Number(item.dataset.line || 0);

      if (!line) return;

      const input =
        item.querySelector(
          ".aleva-cart-qty-input"
        );

      const buttons =
        item.querySelectorAll(
          ".aleva-cart-qty-button"
        );

      quantity =
        Math.max(0, Number(quantity) || 0);

      isUpdating = true;
      item.classList.add("is-updating");

      buttons.forEach(button => {
        button.disabled = true;
      });

      if (input) {
        input.disabled = true;
        input.value = String(quantity);
      }

      try {
        const response = await fetch(
          changeUrl,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
              "Accept":
                "application/json",
              "X-Requested-With":
                "XMLHttpRequest"
            },
            body: JSON.stringify({
              line,
              quantity
            })
          }
        );

        const data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            "Cart update failed."
          );
        }

        /*
          Only after the customer changes a quantity do
          we re-check the 4+1 eligibility. This avoids
          deleting valid gifts during an ordinary page
          load or after selecting a gift.
        */
        await removeNoLongerEarnedGifts(
          data
        );

        window.location.reload();

      } catch (error) {
        console.error(
          "ALEVA cart update error:",
          error
        );

        item.classList.remove("is-updating");

        buttons.forEach(button => {
          button.disabled = false;
        });

        if (input) {
          input.disabled = false;
        }

        alert(cartText("cartUpdateError"));

        isUpdating = false;
      }
    }

    cartRoot
      .querySelectorAll(
        ".aleva-cart-qty-button"
      )
      .forEach(button => {
        button.addEventListener(
          "click",
          () => {
            const item =
              button.closest(
                ".aleva-cart-item"
              );

            const input =
              item?.querySelector(
                ".aleva-cart-qty-input"
              );

            if (!item || !input) return;

            const delta =
              Number(
                button.dataset.delta || 0
              );

            const current =
              Number(input.value || 0);

            changeQuantity(
              item,
              Math.max(0,current + delta)
            );
          }
        );
      });

    cartRoot
      .querySelectorAll(
        ".aleva-cart-qty-input"
      )
      .forEach(input => {
        input.addEventListener(
          "change",
          () => {
            const item =
              input.closest(
                ".aleva-cart-item"
              );

            if (!item) return;

            changeQuantity(
              item,
              Math.max(
                0,
                Number(input.value || 0)
              )
            );
          }
        );
      });

    async function cleanupStaleGiftLinesOnLoad() {
      const staleGiftKeys = [
        ...document.querySelectorAll(
          "[data-stale-gift-key]"
        )
      ]
        .map(node =>
          node.getAttribute(
            "data-stale-gift-key"
          )
        )
        .filter(Boolean);

      if (!staleGiftKeys.length) {
        return false;
      }

      /*
        These keys are generated by Liquid only when
        the corresponding 50/100 ML gift is definitely
        no longer earned. We therefore remove only
        orphaned gift lines, once, and reload once.
      */
      try {
        for (const key of staleGiftKeys) {
          const response = await fetch(
            changeUrl,
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json",
                "X-Requested-With":
                  "XMLHttpRequest"
              },
              body: JSON.stringify({
                id: key,
                quantity: 0
              })
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              data.message ||
              "Stale gift removal failed."
            );
          }
        }

        window.location.reload();
        return true;

      } catch (error) {
        console.error(
          "ALEVA stale gift cleanup error:",
          error
        );

        return false;
      }
    }

    cleanupStaleGiftLinesOnLoad();

    syncHeaderPaidCartCount();
    syncCartCountBreakdown();
    syncGiftProgressLanguage();

    document.addEventListener(
      "aleva:languagechange",
      () => {
        syncHeaderPaidCartCount();
        syncCartCountBreakdown();
        syncGiftProgressLanguage();
        filterGiftCards();
      }
    );

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aleva-cart-pre-mobile-qa"]) return;
  try {
    
  (() => {
    const cartRoot = document.querySelector("[data-aleva-cart]");
    if (!cartRoot) return;

    const translationNode =
      document.getElementById("AlevaCartTranslations");

    let cartTranslations = {};

    try {
      cartTranslations = JSON.parse(
        translationNode?.textContent || "{}"
      );
    } catch (error) {
      console.error(
        "ALEVA cart translations parse error:",
        error
      );
    }

    const cartText = key =>
      cartTranslations[key] || key;

    const cartTemplate = (value, variables = {}) =>
      String(value).replace(
        /__([A-Z]+)__/g,
        (_, key) =>
          variables[key.toLowerCase()] ?? ""
      );

    function syncCartCountBreakdown() {
      const count =
        document.getElementById(
          "alevaCartCountBreakdown"
        );

      if (!count) return;

      const paid =
        Number(count.dataset.paidCount || 0);

      const gifts =
        Number(count.dataset.giftCount || 0);

      let key = "countItems";

      if (gifts > 0) {
        if (paid === 1 && gifts === 1) {
          key = "countOneItemOneGift";
        } else if (paid === 1) {
          key = "countOneItemGifts";
        } else if (gifts === 1) {
          key = "countItemsOneGift";
        } else {
          key = "countItemsGifts";
        }
      } else if (paid === 1) {
        key = "countOneItem";
      }

      count.textContent = cartTemplate(
        cartText(key),
        {
          count: paid,
          paid,
          gifts
        }
      );
    }

    function syncHeaderPaidCartCount() {
      const paid =
        Number(
          cartRoot.dataset.paidItemCount || 0
        );

      const ariaKey =
        paid === 1
          ? "headerCartOne"
          : "headerCartMany";

      const ariaLabel = cartTemplate(
        cartText(ariaKey),
        { count: paid }
      );

      document
        .querySelectorAll(".cart-count")
        .forEach(element => {
          element.textContent =
            String(paid);

          element.setAttribute(
            "aria-label",
            ariaLabel
          );
        });
    }
    let isUpdating = false;
    let giftSize = "50 ML";
    let giftFilter = "all";
    let giftToastTimer;

    const shopRoot =
      window.Shopify?.routes?.root || "/";

    const addUrl =
      `${shopRoot}cart/add.js`;

    const changeUrl =
      `${shopRoot}cart/change.js`;

    const updateUrl =
      `${shopRoot}cart/update.js`;

    const cartJsonUrl =
      `${shopRoot}cart.js`;

    const giftBox =
      document.getElementById("AlevaGiftExperience");

    const drawer =
      document.getElementById("AlevaGiftDrawer");

    const pickerSize =
      document.getElementById("AlevaGiftPickerSize");

    const search =
      document.getElementById("AlevaGiftSearch");

    const emptyResults =
      document.getElementById("AlevaGiftEmptyResults");

    const toast =
      document.getElementById("AlevaGiftToast");

    const giftCards =
      [...document.querySelectorAll("[data-gift-card]")];
    const eligibleOfferProductIds =
      new Set(
        giftCards
          .map(card =>
            String(card.dataset.productId || "")
          )
          .filter(Boolean)
      );

    function showGiftToast(message) {
      if (!toast) return;

      toast.textContent = message;
      toast.classList.add("is-visible");

      clearTimeout(giftToastTimer);

      giftToastTimer = setTimeout(
        () => toast.classList.remove("is-visible"),
        2200
      );
    }

    function giftStatusText(progress) {
      const ready =
        progress.dataset.ready === "true";

      if (ready) {
        return cartText("giftProgressReady");
      }

      const remaining =
        Number(progress.dataset.remaining || 0);

      return cartTemplate(
        cartText("giftProgressNeed"),
        { count: remaining }
      );
    }

    function syncGiftProgressLanguage() {
      document
        .querySelectorAll("[data-gift-progress]")
        .forEach(progress => {
          const status =
            progress.querySelector(
              ".aleva-gift-progress__status"
            );

          if (status) {
            status.textContent =
              giftStatusText(progress);
          }
        });
    }

    async function getCartJson() {
      const response = await fetch(cartJsonUrl, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          "Cart fetch failed."
        );
      }

      return data;
    }

    function getAlevaGiftLines(cart, size = null) {
      return (cart?.items || [])
        .map((item, index) => ({
          item,
          line: index + 1
        }))
        .filter(({ item }) => {
          const isGift =
            String(
              item?.properties?._aleva_gift || ""
            ) === "true";

          if (!isGift) return false;
          if (!size) return true;

          return (
            String(
              item?.properties?._aleva_gift_size || ""
            ) === size
          );
        });
    }

    async function removeAlevaGiftLines(size = null) {
      let cart = await getCartJson();

      const giftLines =
        getAlevaGiftLines(cart, size)
          .sort((a, b) => b.line - a.line);

      for (const giftLine of giftLines) {
        const response = await fetch(
          changeUrl,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
              "Accept":
                "application/json",
              "X-Requested-With":
                "XMLHttpRequest"
            },
            body: JSON.stringify({
              line: giftLine.line,
              quantity: 0
            })
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            "Gift line removal failed."
          );
        }

        cart = data;
      }

      return cart;
    }

    async function addAlevaGiftLine({
      variantId,
      size,
      sku,
      handle
    }) {
      if (!variantId) {
        throw new Error(
          "Missing ALEVA gift variant ID."
        );
      }

      const response = await fetch(
        addUrl,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            "Accept":
              "application/json",
            "X-Requested-With":
              "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: {
                  "_aleva_gift": "true",
                  "_aleva_gift_offer": "4+1",
                  "_aleva_gift_size":
                    size || "",
                  "_aleva_gift_sku":
                    sku || "",
                  "_aleva_gift_handle":
                    handle || ""
                }
              }
            ]
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          "Gift line add failed."
        );
      }

      return data;
    }

    async function clearGift(size, options = {}) {
      if (!size) return;
      if (isUpdating && !options.force) return;

      const previousUpdatingState =
        isUpdating;

      isUpdating = true;

      try {
        await removeAlevaGiftLines(size);

        if (!options.silent) {
          showGiftToast(
            cartText("giftRemovedToast")
          );
        }

        window.setTimeout(
          () => window.location.reload(),
          options.silent ? 0 : 350
        );

      } catch (error) {
        console.error(
          "ALEVA gift remove error:",
          error
        );

        isUpdating =
          previousUpdatingState;
      }
    }

function cardAvailableForSize(card) {
  const attribute =
    giftSize === "100 ML"
      ? "data-variant-100"
      : "data-variant-50";

  return Boolean(
    card.getAttribute(attribute)
  );
}
    function filterGiftCards() {
      const term =
        (search?.value || "")
          .trim()
          .toLowerCase();

      let visible = 0;

      giftCards.forEach(card => {
        const matchesSize =
          cardAvailableForSize(card);

        const matchesFilter =
          giftFilter === "all" ||
          card.dataset.category === giftFilter;

        const matchesSearch =
          !term ||
          (card.dataset.search || "")
            .includes(term);

        const show =
          matchesSize &&
          matchesFilter &&
          matchesSearch;

        card.hidden = !show;

        if (show) visible += 1;
      });

      if (emptyResults) {
        emptyResults.hidden = visible > 0;
      }
    }

    function openGiftDrawer(size) {
      if (!drawer) return;

      giftSize = size || "50 ML";

      if (pickerSize) {
        pickerSize.textContent = giftSize;
      }

      if (search) {
        search.value = "";
      }

      giftFilter = "all";

      document
        .querySelectorAll("[data-gift-filter]")
        .forEach(button => {
          button.classList.toggle(
            "is-active",
            button.dataset.giftFilter === "all"
          );
        });

      filterGiftCards();

      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("aleva-gift-lock");

      window.setTimeout(
        () => search?.focus(),
        280
      );
    }

    function closeGiftDrawer() {
      if (!drawer) return;

      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("aleva-gift-lock");
    }

    document
      .querySelectorAll("[data-gift-open]")
      .forEach(button => {
        button.addEventListener("click", () => {
          openGiftDrawer(
            button.dataset.size || "50 ML"
          );
        });
      });

    document
      .querySelectorAll("[data-gift-close]")
      .forEach(button => {
        button.addEventListener(
          "click",
          closeGiftDrawer
        );
      });

    document
      .querySelectorAll("[data-gift-remove]")
      .forEach(button => {
        button.addEventListener(
          "click",
          () => clearGift(
            button.dataset.size || ""
          )
        );
      });

    document
      .querySelectorAll("[data-gift-filter]")
      .forEach(button => {
        button.addEventListener("click", () => {
          giftFilter =
            button.dataset.giftFilter || "all";

          document
            .querySelectorAll("[data-gift-filter]")
            .forEach(item => {
              item.classList.toggle(
                "is-active",
                item === button
              );
            });

          filterGiftCards();
        });
      });

    search?.addEventListener(
      "input",
      filterGiftCards
    );

    document.addEventListener(
      "keydown",
      event => {
        if (
          event.key === "Escape" &&
          drawer?.classList.contains("is-open")
        ) {
          closeGiftDrawer();
        }
      }
    );

    giftCards.forEach(card => {
      const button =
        card.querySelector(
          "[data-gift-select]"
        );

      button?.addEventListener(
        "click",
        async () => {
          if (isUpdating) return;

          const is100 =
            giftSize === "100 ML";

          const variantId =
            is100
              ? card.getAttribute(
                  "data-variant-100"
                )
              : card.getAttribute(
                  "data-variant-50"
                );

          const sku =
            is100
              ? card.getAttribute(
                  "data-sku-100"
                )
              : card.getAttribute(
                  "data-sku-50"
                );

          /*
            The gift drawer is only exposed from an eligible
            4+1 state, so do not block selection again using
            a duplicated frontend unlock flag. If a variant ID
            exists, Shopify's Cart Ajax API is the final source
            of truth for whether it can be added.
          */
          if (!variantId) {
            showGiftToast(
              cartText("giftUnavailable")
            );
            return;
          }

          isUpdating = true;
          button.disabled = true;

          try {
            /*
              Replace only the gift for the current
              size. A 50 ML gift and a 100 ML gift
              can therefore exist at the same time.
            */
            await removeAlevaGiftLines(
              giftSize
            );

            await addAlevaGiftLine({
              variantId,
              size: giftSize,
              sku: sku || "",
              handle:
                card.dataset.handle || ""
            });

            closeGiftDrawer();

            showGiftToast(
              cartTemplate(
                cartText("giftSavedToast"),
                {
                  name:
                    card.dataset.title || ""
                }
              )
            );

            window.setTimeout(
              () => window.location.reload(),
              520
            );

          } catch (error) {
            console.error(
              "ALEVA gift select error:",
              error
            );

            /*
              Clean only the gift for the size that
              failed. Never remove the other size.
            */
            try {
              await removeAlevaGiftLines(
                giftSize
              );
            } catch (cleanupError) {
              console.error(
                "ALEVA gift cleanup error:",
                cleanupError
              );
            }

            const shopifyMessage =
              error?.message || "";

            showGiftToast(
              shopifyMessage &&
              shopifyMessage !==
                "Gift line add failed."
                ? shopifyMessage
                : cartText("giftError")
            );

            button.disabled = false;
            isUpdating = false;
          }
        }
      );
    });

    function qualifyingCountsFromCart(cart) {
      let count50 = 0;
      let count100 = 0;

      (cart?.items || []).forEach(item => {
        const isGift =
          String(
            item?.properties?._aleva_gift || ""
          ) === "true";

        if (isGift) return;

        const productId =
          String(item?.product_id || "");

        if (!eligibleOfferProductIds.has(productId)) {
          return;
        }

        const variantTitle =
          String(
            item?.variant_title || ""
          )
            .toUpperCase()
            .trim();

        if (variantTitle.includes("50 ML")) {
          count50 += Number(item.quantity || 0);
        } else if (
          variantTitle.includes("100 ML")
        ) {
          count100 += Number(item.quantity || 0);
        }
      });

      return {
        count50,
        count100
      };
    }

    async function removeNoLongerEarnedGifts(cart) {
      const {
        count50,
        count100
      } = qualifyingCountsFromCart(cart);

      if (count50 < 4) {
        await removeAlevaGiftLines(
          "50 ML"
        );
      }

      if (count100 < 4) {
        await removeAlevaGiftLines(
          "100 ML"
        );
      }
    }

    async function changeQuantity(item, quantity) {
      if (!item || isUpdating) return;

      const line =
        Number(item.dataset.line || 0);

      if (!line) return;

      const input =
        item.querySelector(
          ".aleva-cart-qty-input"
        );

      const buttons =
        item.querySelectorAll(
          ".aleva-cart-qty-button"
        );

      quantity =
        Math.max(0, Number(quantity) || 0);

      isUpdating = true;
      item.classList.add("is-updating");

      buttons.forEach(button => {
        button.disabled = true;
      });

      if (input) {
        input.disabled = true;
        input.value = String(quantity);
      }

      try {
        const response = await fetch(
          changeUrl,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
              "Accept":
                "application/json",
              "X-Requested-With":
                "XMLHttpRequest"
            },
            body: JSON.stringify({
              line,
              quantity
            })
          }
        );

        const data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            "Cart update failed."
          );
        }

        /*
          Only after the customer changes a quantity do
          we re-check the 4+1 eligibility. This avoids
          deleting valid gifts during an ordinary page
          load or after selecting a gift.
        */
        await removeNoLongerEarnedGifts(
          data
        );

        window.location.reload();

      } catch (error) {
        console.error(
          "ALEVA cart update error:",
          error
        );

        item.classList.remove("is-updating");

        buttons.forEach(button => {
          button.disabled = false;
        });

        if (input) {
          input.disabled = false;
        }

        alert(cartText("cartUpdateError"));

        isUpdating = false;
      }
    }

    cartRoot
      .querySelectorAll(
        ".aleva-cart-qty-button"
      )
      .forEach(button => {
        button.addEventListener(
          "click",
          () => {
            const item =
              button.closest(
                ".aleva-cart-item"
              );

            const input =
              item?.querySelector(
                ".aleva-cart-qty-input"
              );

            if (!item || !input) return;

            const delta =
              Number(
                button.dataset.delta || 0
              );

            const current =
              Number(input.value || 0);

            changeQuantity(
              item,
              Math.max(0,current + delta)
            );
          }
        );
      });

    cartRoot
      .querySelectorAll(
        ".aleva-cart-qty-input"
      )
      .forEach(input => {
        input.addEventListener(
          "change",
          () => {
            const item =
              input.closest(
                ".aleva-cart-item"
              );

            if (!item) return;

            changeQuantity(
              item,
              Math.max(
                0,
                Number(input.value || 0)
              )
            );
          }
        );
      });

    async function cleanupStaleGiftLinesOnLoad() {
      const staleGiftKeys = [
        ...document.querySelectorAll(
          "[data-stale-gift-key]"
        )
      ]
        .map(node =>
          node.getAttribute(
            "data-stale-gift-key"
          )
        )
        .filter(Boolean);

      if (!staleGiftKeys.length) {
        return false;
      }

      /*
        These keys are generated by Liquid only when
        the corresponding 50/100 ML gift is definitely
        no longer earned. We therefore remove only
        orphaned gift lines, once, and reload once.
      */
      try {
        for (const key of staleGiftKeys) {
          const response = await fetch(
            changeUrl,
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json",
                "X-Requested-With":
                  "XMLHttpRequest"
              },
              body: JSON.stringify({
                id: key,
                quantity: 0
              })
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              data.message ||
              "Stale gift removal failed."
            );
          }
        }

        window.location.reload();
        return true;

      } catch (error) {
        console.error(
          "ALEVA stale gift cleanup error:",
          error
        );

        return false;
      }
    }

    cleanupStaleGiftLinesOnLoad();

    syncHeaderPaidCartCount();
    syncCartCountBreakdown();
    syncGiftProgressLanguage();

    document.addEventListener(
      "aleva:languagechange",
      () => {
        syncHeaderPaidCartCount();
        syncCartCountBreakdown();
        syncGiftProgressLanguage();
        filterGiftCards();
      }
    );

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const cartRoot = document.querySelector("[data-aleva-cart]");
    if (!cartRoot) return;

    const translationNode =
      document.getElementById("AlevaCartTranslations");

    let cartTranslations = {};

    try {
      cartTranslations = JSON.parse(
        translationNode?.textContent || "{}"
      );
    } catch (error) {
      console.error(
        "ALEVA cart translations parse error:",
        error
      );
    }

    const cartText = key =>
      cartTranslations[key] || key;

    const cartTemplate = (value, variables = {}) =>
      String(value).replace(
        /__([A-Z]+)__/g,
        (_, key) =>
          variables[key.toLowerCase()] ?? ""
      );

    function syncCartCountBreakdown() {
      const count =
        document.getElementById(
          "alevaCartCountBreakdown"
        );

      if (!count) return;

      const paid =
        Number(count.dataset.paidCount || 0);

      const gifts =
        Number(count.dataset.giftCount || 0);

      let key = "countItems";

      if (gifts > 0) {
        if (paid === 1 && gifts === 1) {
          key = "countOneItemOneGift";
        } else if (paid === 1) {
          key = "countOneItemGifts";
        } else if (gifts === 1) {
          key = "countItemsOneGift";
        } else {
          key = "countItemsGifts";
        }
      } else if (paid === 1) {
        key = "countOneItem";
      }

      count.textContent = cartTemplate(
        cartText(key),
        {
          count: paid,
          paid,
          gifts
        }
      );
    }

    function syncHeaderPaidCartCount() {
      const paid =
        Number(
          cartRoot.dataset.paidItemCount || 0
        );

      const ariaKey =
        paid === 1
          ? "headerCartOne"
          : "headerCartMany";

      const ariaLabel = cartTemplate(
        cartText(ariaKey),
        { count: paid }
      );

      document
        .querySelectorAll(".cart-count")
        .forEach(element => {
          element.textContent =
            String(paid);

          element.setAttribute(
            "aria-label",
            ariaLabel
          );
        });
    }
    let isUpdating = false;
    let giftSize = "50 ML";
    let giftFilter = "all";
    let giftToastTimer;

    const shopRoot =
      window.Shopify?.routes?.root || "/";

    const addUrl =
      `${shopRoot}cart/add.js`;

    const changeUrl =
      `${shopRoot}cart/change.js`;

    const updateUrl =
      `${shopRoot}cart/update.js`;

    const cartJsonUrl =
      `${shopRoot}cart.js`;

    const giftBox =
      document.getElementById("AlevaGiftExperience");

    const drawer =
      document.getElementById("AlevaGiftDrawer");

    const pickerSize =
      document.getElementById("AlevaGiftPickerSize");

    const search =
      document.getElementById("AlevaGiftSearch");

    const emptyResults =
      document.getElementById("AlevaGiftEmptyResults");

    const toast =
      document.getElementById("AlevaGiftToast");

    const giftCards =
      [...document.querySelectorAll("[data-gift-card]")];
    const eligibleOfferProductIds =
      new Set(
        giftCards
          .map(card =>
            String(card.dataset.productId || "")
          )
          .filter(Boolean)
      );

    function showGiftToast(message) {
      if (!toast) return;

      toast.textContent = message;
      toast.classList.add("is-visible");

      clearTimeout(giftToastTimer);

      giftToastTimer = setTimeout(
        () => toast.classList.remove("is-visible"),
        2200
      );
    }

    function giftStatusText(progress) {
      const ready =
        progress.dataset.ready === "true";

      if (ready) {
        return cartText("giftProgressReady");
      }

      const remaining =
        Number(progress.dataset.remaining || 0);

      return cartTemplate(
        cartText("giftProgressNeed"),
        { count: remaining }
      );
    }

    function syncGiftProgressLanguage() {
      document
        .querySelectorAll("[data-gift-progress]")
        .forEach(progress => {
          const status =
            progress.querySelector(
              ".aleva-gift-progress__status"
            );

          if (status) {
            status.textContent =
              giftStatusText(progress);
          }
        });
    }

    async function getCartJson() {
      const response = await fetch(cartJsonUrl, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          "Cart fetch failed."
        );
      }

      return data;
    }

    function getAlevaGiftLines(cart, size = null) {
      return (cart?.items || [])
        .map((item, index) => ({
          item,
          line: index + 1
        }))
        .filter(({ item }) => {
          const isGift =
            String(
              item?.properties?._aleva_gift || ""
            ) === "true";

          if (!isGift) return false;
          if (!size) return true;

          return (
            String(
              item?.properties?._aleva_gift_size || ""
            ) === size
          );
        });
    }

    async function removeAlevaGiftLines(size = null) {
      let cart = await getCartJson();

      const giftLines =
        getAlevaGiftLines(cart, size)
          .sort((a, b) => b.line - a.line);

      for (const giftLine of giftLines) {
        const response = await fetch(
          changeUrl,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
              "Accept":
                "application/json",
              "X-Requested-With":
                "XMLHttpRequest"
            },
            body: JSON.stringify({
              line: giftLine.line,
              quantity: 0
            })
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            "Gift line removal failed."
          );
        }

        cart = data;
      }

      return cart;
    }

    async function addAlevaGiftLine({
      variantId,
      size,
      sku,
      handle
    }) {
      if (!variantId) {
        throw new Error(
          "Missing ALEVA gift variant ID."
        );
      }

      const response = await fetch(
        addUrl,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            "Accept":
              "application/json",
            "X-Requested-With":
              "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: {
                  "_aleva_gift": "true",
                  "_aleva_gift_offer": "4+1",
                  "_aleva_gift_size":
                    size || "",
                  "_aleva_gift_sku":
                    sku || "",
                  "_aleva_gift_handle":
                    handle || ""
                }
              }
            ]
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          "Gift line add failed."
        );
      }

      return data;
    }

    async function clearGift(size, options = {}) {
      if (!size) return;
      if (isUpdating && !options.force) return;

      const previousUpdatingState =
        isUpdating;

      isUpdating = true;

      try {
        await removeAlevaGiftLines(size);

        if (!options.silent) {
          showGiftToast(
            cartText("giftRemovedToast")
          );
        }

        window.setTimeout(
          () => window.location.reload(),
          options.silent ? 0 : 350
        );

      } catch (error) {
        console.error(
          "ALEVA gift remove error:",
          error
        );

        isUpdating =
          previousUpdatingState;
      }
    }

function cardAvailableForSize(card) {
  const is100 = giftSize === "100 ML";
  const variant = card.getAttribute(
    is100 ? "data-variant-100" : "data-variant-50"
  );
  const available = card.getAttribute(
    is100 ? "data-available-100" : "data-available-50"
  );
  return Boolean(variant) && available === "true";
}
    function filterGiftCards() {
      const term =
        (search?.value || "")
          .trim()
          .toLowerCase();

      let visible = 0;

      giftCards.forEach(card => {
        const matchesSize =
          cardAvailableForSize(card);

        const matchesFilter =
          giftFilter === "all" ||
          card.dataset.category === giftFilter;

        const matchesSearch =
          !term ||
          (card.dataset.search || "")
            .includes(term);

        const show =
          matchesSize &&
          matchesFilter &&
          matchesSearch;

        card.hidden = !show;

        if (show) visible += 1;
      });

      if (emptyResults) {
        emptyResults.hidden = visible > 0;
      }
    }

    function openGiftDrawer(size) {
      if (!drawer) return;

      giftSize = size || "50 ML";

      if (pickerSize) {
        pickerSize.textContent = giftSize;
      }

      if (search) {
        search.value = "";
      }

      giftFilter = "all";

      document
        .querySelectorAll("[data-gift-filter]")
        .forEach(button => {
          button.classList.toggle(
            "is-active",
            button.dataset.giftFilter === "all"
          );
        });

      filterGiftCards();

      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("aleva-gift-lock");

      window.setTimeout(
        () => search?.focus(),
        280
      );
    }

    function closeGiftDrawer() {
      if (!drawer) return;

      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("aleva-gift-lock");
    }

    document
      .querySelectorAll("[data-gift-open]")
      .forEach(button => {
        button.addEventListener("click", () => {
          openGiftDrawer(
            button.dataset.size || "50 ML"
          );
        });
      });

    document
      .querySelectorAll("[data-gift-close]")
      .forEach(button => {
        button.addEventListener(
          "click",
          closeGiftDrawer
        );
      });

    document
      .querySelectorAll("[data-gift-remove]")
      .forEach(button => {
        button.addEventListener(
          "click",
          () => clearGift(
            button.dataset.size || ""
          )
        );
      });

    document
      .querySelectorAll("[data-gift-filter]")
      .forEach(button => {
        button.addEventListener("click", () => {
          giftFilter =
            button.dataset.giftFilter || "all";

          document
            .querySelectorAll("[data-gift-filter]")
            .forEach(item => {
              item.classList.toggle(
                "is-active",
                item === button
              );
            });

          filterGiftCards();
        });
      });

    search?.addEventListener(
      "input",
      filterGiftCards
    );

    document.addEventListener(
      "keydown",
      event => {
        if (
          event.key === "Escape" &&
          drawer?.classList.contains("is-open")
        ) {
          closeGiftDrawer();
        }
      }
    );

    giftCards.forEach(card => {
      const button =
        card.querySelector(
          "[data-gift-select]"
        );

      button?.addEventListener(
        "click",
        async () => {
          if (isUpdating) return;

          const is100 =
            giftSize === "100 ML";

          const variantId =
            is100
              ? card.getAttribute(
                  "data-variant-100"
                )
              : card.getAttribute(
                  "data-variant-50"
                );

          const sku =
            is100
              ? card.getAttribute(
                  "data-sku-100"
                )
              : card.getAttribute(
                  "data-sku-50"
                );

          /*
            The gift drawer is only exposed from an eligible
            4+1 state, so do not block selection again using
            a duplicated frontend unlock flag. If a variant ID
            exists, Shopify's Cart Ajax API is the final source
            of truth for whether it can be added.
          */
          if (!variantId) {
            showGiftToast(
              cartText("giftUnavailable")
            );
            return;
          }

          isUpdating = true;
          button.disabled = true;

          try {
            /*
              Replace only the gift for the current
              size. A 50 ML gift and a 100 ML gift
              can therefore exist at the same time.
            */
            await removeAlevaGiftLines(
              giftSize
            );

            await addAlevaGiftLine({
              variantId,
              size: giftSize,
              sku: sku || "",
              handle:
                card.dataset.handle || ""
            });

            closeGiftDrawer();

            showGiftToast(
              cartTemplate(
                cartText("giftSavedToast"),
                {
                  name:
                    card.dataset.title || ""
                }
              )
            );

            window.setTimeout(
              () => window.location.reload(),
              520
            );

          } catch (error) {
            console.error(
              "ALEVA gift select error:",
              error
            );

            /*
              Clean only the gift for the size that
              failed. Never remove the other size.
            */
            try {
              await removeAlevaGiftLines(
                giftSize
              );
            } catch (cleanupError) {
              console.error(
                "ALEVA gift cleanup error:",
                cleanupError
              );
            }

            const shopifyMessage =
              error?.message || "";

            showGiftToast(
              shopifyMessage &&
              shopifyMessage !==
                "Gift line add failed."
                ? shopifyMessage
                : cartText("giftError")
            );

            button.disabled = false;
            isUpdating = false;
          }
        }
      );
    });

    function qualifyingCountsFromCart(cart) {
      let count50 = 0;
      let count100 = 0;

      (cart?.items || []).forEach(item => {
        const isGift =
          String(
            item?.properties?._aleva_gift || ""
          ) === "true";

        if (isGift) return;

        const productId =
          String(item?.product_id || "");

        if (!eligibleOfferProductIds.has(productId)) {
          return;
        }

        const variantTitle =
          String(
            item?.variant_title || ""
          )
            .toUpperCase()
            .trim();

        if (variantTitle.includes("50 ML")) {
          count50 += Number(item.quantity || 0);
        } else if (
          variantTitle.includes("100 ML")
        ) {
          count100 += Number(item.quantity || 0);
        }
      });

      return {
        count50,
        count100
      };
    }

    async function removeNoLongerEarnedGifts(cart) {
      const {
        count50,
        count100
      } = qualifyingCountsFromCart(cart);

      if (count50 < 4) {
        await removeAlevaGiftLines(
          "50 ML"
        );
      }

      if (count100 < 4) {
        await removeAlevaGiftLines(
          "100 ML"
        );
      }
    }

    async function changeQuantity(item, quantity) {
      if (!item || isUpdating) return;

      const line =
        Number(item.dataset.line || 0);

      if (!line) return;

      const input =
        item.querySelector(
          ".aleva-cart-qty-input"
        );

      const buttons =
        item.querySelectorAll(
          ".aleva-cart-qty-button"
        );

      quantity =
        Math.max(0, Number(quantity) || 0);

      isUpdating = true;
      item.classList.add("is-updating");

      buttons.forEach(button => {
        button.disabled = true;
      });

      if (input) {
        input.disabled = true;
        input.value = String(quantity);
      }

      try {
        const response = await fetch(
          changeUrl,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
              "Accept":
                "application/json",
              "X-Requested-With":
                "XMLHttpRequest"
            },
            body: JSON.stringify({
              line,
              quantity
            })
          }
        );

        const data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            "Cart update failed."
          );
        }

        /*
          Only after the customer changes a quantity do
          we re-check the 4+1 eligibility. This avoids
          deleting valid gifts during an ordinary page
          load or after selecting a gift.
        */
        await removeNoLongerEarnedGifts(
          data
        );

        window.location.reload();

      } catch (error) {
        console.error(
          "ALEVA cart update error:",
          error
        );

        item.classList.remove("is-updating");

        buttons.forEach(button => {
          button.disabled = false;
        });

        if (input) {
          input.disabled = false;
        }

        alert(cartText("cartUpdateError"));

        isUpdating = false;
      }
    }

    // Route remove through the same cart update path as quantity changes.
    // This rechecks earned 4+1 gifts after deleting a paid cart line.
    cartRoot
      .querySelectorAll(".aleva-cart-item__remove")
      .forEach(link => {
        link.addEventListener("click", event => {
          event.preventDefault();
          if (isUpdating) return;
          const item = link.closest(".aleva-cart-item");
          if (!item || !Number(item.dataset.line)) {
            window.location.assign(link.href);
            return;
          }
          changeQuantity(item, 0);
        });
      });

    cartRoot
      .querySelectorAll(
        ".aleva-cart-qty-button"
      )
      .forEach(button => {
        button.addEventListener(
          "click",
          () => {
            const item =
              button.closest(
                ".aleva-cart-item"
              );

            const input =
              item?.querySelector(
                ".aleva-cart-qty-input"
              );

            if (!item || !input) return;

            const delta =
              Number(
                button.dataset.delta || 0
              );

            const current =
              Number(input.value || 0);

            changeQuantity(
              item,
              Math.max(0,current + delta)
            );
          }
        );
      });

    cartRoot
      .querySelectorAll(
        ".aleva-cart-qty-input"
      )
      .forEach(input => {
        input.addEventListener(
          "change",
          () => {
            const item =
              input.closest(
                ".aleva-cart-item"
              );

            if (!item) return;

            changeQuantity(
              item,
              Math.max(
                0,
                Number(input.value || 0)
              )
            );
          }
        );
      });

    async function cleanupStaleGiftLinesOnLoad() {
      const staleGiftKeys = [
        ...document.querySelectorAll(
          "[data-stale-gift-key]"
        )
      ]
        .map(node =>
          node.getAttribute(
            "data-stale-gift-key"
          )
        )
        .filter(Boolean);

      if (!staleGiftKeys.length) {
        return false;
      }

      /*
        These keys are generated by Liquid only when
        the corresponding 50/100 ML gift is definitely
        no longer earned. We therefore remove only
        orphaned gift lines, once, and reload once.
      */
      try {
        for (const key of staleGiftKeys) {
          const response = await fetch(
            changeUrl,
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json",
                "X-Requested-With":
                  "XMLHttpRequest"
              },
              body: JSON.stringify({
                id: key,
                quantity: 0
              })
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              data.message ||
              "Stale gift removal failed."
            );
          }
        }

        window.location.reload();
        return true;

      } catch (error) {
        console.error(
          "ALEVA stale gift cleanup error:",
          error
        );

        return false;
      }
    }

    cleanupStaleGiftLinesOnLoad();

    syncHeaderPaidCartCount();
    syncCartCountBreakdown();
    syncGiftProgressLanguage();

    document.addEventListener(
      "aleva:languagechange",
      () => {
        syncHeaderPaidCartCount();
        syncCartCountBreakdown();
        syncGiftProgressLanguage();
        filterGiftCards();
      }
    );

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recs-pre-i18n-20260916"] && !Shopify.designMode) return;
  try {
    
  const productJsonElement = document.getElementById('AlevaProductJson');
  const productRoot = document.querySelector('[data-aleva-product]');
  const productName = document.getElementById('pdpName');

  if (productJsonElement && productRoot && productName) {
    try {
      const productData = JSON.parse(productJsonElement.textContent || '{}');
      const productCode = productRoot.dataset.productCode;

      if (productData.vendor === 'Aleva Parfüme' && productCode) {
        productName.textContent = `ALEVA ${productCode}`;
      }
    } catch (error) {
      /* Keep the original product title when product JSON is unavailable. */
    }
  }

  document.querySelectorAll('[data-aleva-recommendations]').forEach((section) => {
    if (section.dataset.recommendationsInitialized === 'true') return;
    section.dataset.recommendationsInitialized = 'true';

    const loadRecommendations = async () => {
      if (!section.dataset.url || section.dataset.recommendationsLoaded === 'true') return;

      section.dataset.recommendationsLoaded = 'true';

      try {
        const response = await fetch(section.dataset.url, {
          headers: { Accept: 'text/html' }
        });

        if (!response.ok) return;

        const text = await response.text();
        const wrapper = document.createElement('div');
        wrapper.innerHTML = text;
        const nextSection = wrapper.querySelector('[data-aleva-recommendations]');

        if (nextSection?.innerHTML.trim()) {
          section.innerHTML = nextSection.innerHTML;
        }
      } catch (error) {
        /* Recommendations are optional and must never block the PDP. */
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 320px 0px' });

      observer.observe(section);
    } else {
      loadRecommendations();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
